import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, Button, Spinner } from "@heroui/react";
import { ArrowLeft } from "lucide-react";

import { customersService } from "@/services/customersService";
import { Customer } from "@/types/customers";
import OrderForm from "@/components/orders/OrderForm";

export default function CreateOrderPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId")
    ? parseInt(searchParams.get("customerId")!)
    : null;

  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    // Si se proporciona un customerId en la URL, cargamos los datos del cliente
    if (customerId) {
      fetchCustomerData();
    }
  }, [customerId]);

  const fetchCustomerData = async () => {
    try {
      setLoading(true);
      const data = await customersService.getCustomerById(customerId!);

      setCustomer(data);
    } catch (err) {
      console.error("Error al cargar datos del cliente:", err);
      setError("No se pudo cargar la información del cliente");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/orders");
  };

  return (
    <div className="p-4 space-y-6">
      <div className="flex items-center gap-2">
        <Button isIconOnly variant="light" onPress={handleBack}>
          <ArrowLeft size={18} />
        </Button>
        <h1 className="text-2xl font-bold">Create New Order</h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center p-8">
          <Spinner size="lg" />
        </div>
      ) : error ? (
        <Card className="p-6">
          <div className="text-center text-danger">
            <p>{error}</p>
            <Button color="primary" className="mt-4" onPress={handleBack}>
              Back to Orders
            </Button>
          </div>
        </Card>
      ) : (
        <OrderForm
          preselectedCustomer={customer}
        />
      )}
    </div>
  );
}
